import type { Ticket } from './types'

/** A called customer from a line; no limit on how often. One called out of a pool
 *  goes back there by No-show (the server refuses it otherwise). */
export function offersBackToQueue(t: Pick<Ticket, 'state' | 'queueId' | 'parkScope'>): boolean {
  return t.state === 'called' && Boolean(t.queueId) && !t.parkScope
}
